module.exports = __webpack_public_path__ + "static/media/obchodnirejstrik.a99009bc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/obchodnirejstrik.pdf
// module id = 378
// module chunks = 0